"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function calc(a, b, op) {
    switch (op) {
        case '+': return a + b;
        case '-': return a - b;
        case '*': return a * b;
        case '/': return a / b;
        case '//': return Math.floor(a / b);
        case '^': return Math.pow(a, b);
        case '_': return a.toFixed(b);
        case 'mod': return a % b;
        default: throw new SyntaxError(`Invalid Operand: ${op}`);
    }
}
function default_1(...args) {
    let s = [];
    let lastPushed = 0;
    for (let t of args) {
        if (typeof t === 'number') {
            s.push(t);
            lastPushed = t;
        }
        else {
            let op2 = s.pop();
            let op1 = s.pop();
            if (op1 === undefined || op2 === undefined) {
                throw new Error('Invalid RPN Expression');
            }
            lastPushed = calc(op1, op2, t);
            s.push(parseFloat(lastPushed));
        }
    }
    if (s.length !== 1) {
        throw new Error('RPN Expression Overflowed');
    }
    return lastPushed.toString();
}
exports.default = default_1;
